import React from 'react'
import { DragSource, DropTarget } from 'react-dnd'
import Piece from './PuzzlePiece'
import * as styles from './PuzzleCell.module.scss'

const Cell = props => {
  const {
    image,
    position,
    connectDropTarget,
    isOver,
    rows,
    cols,
    width,
    height,
    puzzleMaxWidth,
    puzzleMaxHeight,
  } = props
  const x =
    width < puzzleMaxWidth
      ? ((position % cols) * width) / cols
      : ((position % cols) * puzzleMaxWidth) / cols
  const y =
    width < puzzleMaxWidth
      ? (Math.floor(position / cols) * width) / cols
      : (Math.floor(position / cols) * puzzleMaxHeight) / rows

  return connectDropTarget(
    <div className={styles.puzzleTileContainer}>
      <Piece
        width={width}
        height={height}
        position={position}
        cols={cols}
        rows={rows}
        puzzleMaxWidth={puzzleMaxWidth}
        puzzleMaxHeight={puzzleMaxHeight}
        image={image}
        x={x}
        y={y}
        isOver={isOver}
      />
    </div>,
  )
}

const squareTarget = {
  drop(props, monitor) {
    const item = monitor.getItem()
    const sourcePosition = item.position
    const dropPosition = props.position

    if (!props.isSubmitted) {
      props.onSwap(sourcePosition, dropPosition)
    }
  },
}

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  }
}

export default DropTarget('piece', squareTarget, collect)(Cell)
